// trix_extensions.js
import { DirectUpload } from "@rails/activestorage";

document.addEventListener("trix-initialize", function (event) {
  const trixEditor = event.target; // <trix-editor> that just initialized
  const editor = trixEditor.editor;
  const toolbar = trixEditor.toolbarElement;

  if (!toolbar || !editor) {
    return;
  }

  // Avoid double-binding if Vite / Turbo re-renders
  if (trixEditor.dataset.trixCustomBound === "true") {
    return;
  }
  trixEditor.dataset.trixCustomBound = "true";

  // ---- TABLE BUTTON ----
  const tableButton = toolbar.querySelector("button[data-behavior='insert-table']");
  if (tableButton) {
    tableButton.addEventListener("click", function () {
      console.log("Table button clicked");
      // Insert a proper 3x3 table with styling
      const tableHTML = `
        <table style="width: 100%; border-collapse: collapse; margin: 1rem 0; border: 1px solid #d1d5db;">
          <thead>
            <tr>
              <th style="border: 1px solid #d1d5db; padding: 0.5rem; background-color: #f3f4f6; font-weight: 600;">Header 1</th>
              <th style="border: 1px solid #d1d5db; padding: 0.5rem; background-color: #f3f4f6; font-weight: 600;">Header 2</th>
              <th style="border: 1px solid #d1d5db; padding: 0.5rem; background-color: #f3f4f6; font-weight: 600;">Header 3</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #d1d5db; padding: 0.5rem; background-color: white;">Cell</td>
              <td style="border: 1px solid #d1d5db; padding: 0.5rem; background-color: white;">Cell</td>
              <td style="border: 1px solid #d1d5db; padding: 0.5rem; background-color: white;">Cell</td>
            </tr>
            <tr>
              <td style="border: 1px solid #d1d5db; padding: 0.5rem; background-color: white;">Cell</td>
              <td style="border: 1px solid #d1d5db; padding: 0.5rem; background-color: white;">Cell</td>
              <td style="border: 1px solid #d1d5db; padding: 0.5rem; background-color: white;">Cell</td>
            </tr>
          </tbody>
        </table>
        <p><br></p>
      `;
      editor.insertHTML(tableHTML);
    });
    console.log("Table button found:", tableButton);
  }

  // ---- EMOJI BUTTON ----
  const emojiButton = toolbar.querySelector("button[data-behavior='emoji-picker']");
  if (emojiButton) {
    // Create emoji picker dialog
    const emojiDialog = document.createElement('div');
    emojiDialog.className = 'trix-dialog trix-dialog--emoji';
    emojiDialog.style.cssText = `
      display: none;
      position: absolute;
      background: white;
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 12px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 1000;
      max-width: 320px;
      grid-template-columns: repeat(8, 1fr);
      gap: 4px;
    `;

    // Common emojis
    const emojis = [
      '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂',
      '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩',
      '😘', '😗', '😚', '😙', '😋', '😛', '😜', '🤪',
      '😎', '🤓', '🧐', '🤔', '🤨', '😐', '😑', '😶',
      '👍', '👎', '👏', '🙌', '👊', '✊', '🤝', '🙏',
      '✅', '❌', '⚠️', '🎯', '🎉', '🎊', '🔥', '💡',
      '💯', '✨', '⭐', '🌟', '💥', '💫', '🚀', '🏆',
      '📝', '📋', '📌', '📍', '🔖', '📁', '📂', '📊'
    ];

    emojis.forEach(emoji => {
      const emojiBtn = document.createElement('button');
      emojiBtn.type = 'button';
      emojiBtn.textContent = emoji;
      emojiBtn.style.cssText = `
        border: none;
        background: transparent;
        font-size: 24px;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        transition: background 0.2s;
      `;

      emojiBtn.addEventListener('mouseenter', function() {
        this.style.background = '#f0f0f0';
      });

      emojiBtn.addEventListener('mouseleave', function() {
        this.style.background = 'transparent';
      });

      emojiBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        editor.insertString(emoji);
        emojiDialog.style.display = 'none';
      });

      emojiDialog.appendChild(emojiBtn);
    });

    // Toggle emoji picker
    emojiButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (emojiDialog.style.display === 'grid') {
        emojiDialog.style.display = 'none';
      } else {
        // Position the dialog
        const rect = emojiButton.getBoundingClientRect();
        emojiDialog.style.display = 'grid';
        emojiDialog.style.top = (rect.bottom + 5) + 'px';
        emojiDialog.style.left = rect.left + 'px';
      }
    });

    // Close picker when clicking outside
    document.addEventListener('click', function(e) {
      if (!emojiButton.contains(e.target) && !emojiDialog.contains(e.target)) {
        emojiDialog.style.display = 'none';
      }
    });

    document.body.appendChild(emojiDialog);
    console.log("Emoji button found:", emojiButton);
  }

  // ---- IMAGE BUTTON ----
  const imageButton = toolbar.querySelector("button[data-behavior='insert-image']");
  if (imageButton) {
    // create one hidden input per editor
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*";
    fileInput.multiple = true;
    fileInput.style.display = "none";
    document.body.appendChild(fileInput);

    imageButton.addEventListener("click", function () {
      fileInput.click();
    });

    fileInput.addEventListener("change", function (e) {
      const files = Array.from(e.target.files || []);
      const uploadUrl = document.querySelector('meta[name="direct-upload-url"]')?.content;

      files.forEach(function (file) {
        if (!uploadUrl) {
          console.error("Direct upload URL not found. Add direct-upload-url meta tag to layout.");
          return;
        }

        const upload = new DirectUpload(file, uploadUrl);
        upload.create(function (error, blob) {
          if (error) {
            console.error("Direct upload failed:", error);
            return;
          }

          const attachment = new Trix.Attachment({
            sgid: blob.attachable_sgid,
            url: `/rails/active_storage/blobs/redirect/${blob.signed_id}/${blob.filename}`,
            href: `/rails/active_storage/blobs/redirect/${blob.signed_id}/${blob.filename}`,
            filename: blob.filename,
            contentType: blob.content_type,
            filesize: blob.byte_size
          });
          editor.insertAttachment(attachment);
        });
      });
      // reset so the same file can be chosen again
      fileInput.value = "";
    });

    console.log("Image button found:", imageButton);
  }

  console.log("Trix Extensions: custom buttons bound for one editor");
});

// Add CSS for enhanced styling
const style = document.createElement('style');
style.textContent = `
  .trix-button--icon-table svg,
  .trix-button--icon-image svg {
    width: 16px;
    height: 16px;
  }

  .trix-button--icon-emoji {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Color Emoji", sans-serif;
  }

  /* Improve table editing in Trix */
  trix-editor table {
    border-collapse: collapse;
    width: 100%;
    margin: 1rem 0;
  }

  trix-editor table th,
  trix-editor table td {
    border: 1px solid #d1d5db;
    padding: 0.5rem;
    min-width: 80px;
  }

  trix-editor table th {
    background-color: #f3f4f6;
    font-weight: 600;
  }

  trix-editor table td {
    background-color: white;
  }

  /* Make table cells editable */
  trix-editor table th[contenteditable],
  trix-editor table td[contenteditable] {
    outline: 2px solid #6366f1 !important;
    outline-offset: -2px;
  }

  /* Image attachment styling in editor */
  trix-editor img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 1rem auto;
    border-radius: 0.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  /* Attachment progress indicator */
  trix-editor .attachment--preview {
    position: relative;
  }

  trix-editor .attachment__progress {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: rgba(99, 102, 241, 0.2);
    border-radius: 2px;
    overflow: hidden;
  }

  trix-editor .attachment__progress::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: #6366f1;
    animation: progress 2s ease-in-out infinite;
  }

  @keyframes progress {
    0% { width: 0%; }
    50% { width: 70%; }
    100% { width: 100%; }
  }

  /* Better spacing for embedded content */
  trix-editor action-text-attachment {
    display: block;
    margin: 1.5rem 0;
  }
`;
document.head.appendChild(style);
